module.exports = __webpack_public_path__ + "static/media/mus_musculus.brain.bbbcce33.svg";